export default __webpack_public_path__ + "static/media/passenger.d9f16084.svg";